// 设置符号——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `icon/set/index${i + 1}`,
  name: `icon/setIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/set/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置符号——主流程，开始
    ...MainRoutes,
  ],
};
